import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';

export function SessionRepairRedirectPage() {
  const { sessionId } = useParams();

  useEffect(() => {
    if (sessionId) {
      notifications.show({
        color: 'blue',
        title: 'Riparazione spostata',
        message:
          'Apri un gruppo sessioni e seleziona la sessione da analizzare o riparare.',
        autoClose: 5000,
      });
    }
  }, [sessionId]);

  return <Navigate to='/sessions/group' replace />;
}
